// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { miniSignInStyles } from "@guestsupply/App/Components/MiniSignIn/MiniSignIn";
import { color, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";


miniSignInStyles.container = {
    css: css`
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        padding: 17px;
    `,
};

miniSignInStyles.registrationSection = {
    wrapper: {
        css: css`
            border-top: 1px solid ${color("common.ui10")};
            margin-top: 20px;
            padding-top: 22px;
            width: 100%;
            display: flex;
            row-gap: 12px;
            flex-wrap: wrap;
        `,
    },
    title: {
        variant: "h6",
        css: css`
            margin-bottom: 8px;
            width: 100%;
        `,
    },
    requestAccessButton: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            css: css`
                line-height: 15px;
            `,
        },
    },
    createAccountButton: {
        variant: "tertiary",
        css: css`
            width: 100%;
        `,
        typographyProps: {
            css: css`
                line-height: 15px;
            `,
        },
    },
};